import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams((window.location.hash || "").replace(/^#/, ""));
    const sid = params.get("session_id");
    const finish = async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, { headers: { "X-Session-ID": sid } });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        const dest = data.role === "super_admin" ? "/super"
          : data.role === "staff" ? "/staff"
          : (data.role === "admin" || data.role === "branch_admin") ? "/admin" : "/account";
        navigate(dest, { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    if (sid) finish(); else navigate("/login", { replace: true });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-metros-black">
        <Loader2 className="animate-spin" size={28} />
        <p className="font-semibold">Signing you in…</p>
      </div>
    </div>
  );
}
